export const nothing = (): never => {
  return undefined as never;
};
